import { render, staticRenderFns } from "./checkEarPhone.vue?vue&type=template&id=32c23061&scoped=true&"
import script from "./checkEarPhone.vue?vue&type=script&lang=js&"
export * from "./checkEarPhone.vue?vue&type=script&lang=js&"
import style0 from "./checkEarPhone.vue?vue&type=style&index=0&id=32c23061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c23061",
  null
  
)

export default component.exports